/**
 * OAuth2 provider names.
 */
export enum OAuth2Provider {
  clever = 'clever',
  google = 'google',
  classlink = 'classlink',
}
